<template>
	<div
		class="panel research-chart"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
			<div class="container">
				<div
					v-if="isHeaderVisible"
					:class="[
						'panel_header',
						isBrand? 'sk' : '',
					]"
				>
					<div class="row align-items-end">
						<div class="col-12">
							<h2>{{ block.block_title }}</h2>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-12 col-lg-4">
						<!-- subtitle - поле ввода в админке, может быть не заполнена, но div показываем всегда -->
						<div class="subtitle text-center text-sm-left" />

						<!-- Вот этот блок выводим когда прикреплен "Эксперт" к комментарию (цитате) -->
						<div v-if="block.person" class="row mb-4 mb-lg-0">
							<div v-if="block.person.square_photo" class="col-8 offset-2 offset-sm-0 col-sm-4 col-md-4 col-lg-4 mb-3 mb-sm-0">
								<img :src="block.person.square_photo" class="rounded-circle">
							</div>
							<div class="col-12 col-sm-8 col-md-8 col-lg-8 align-self-center text-center text-sm-left">
								<div v-if="block.person.title" class="title">
									{{ block.person.title }}
								</div>
								<div v-if="block.person.job_title" class="description" v-html="block.person.job_title" />
							</div>
						</div>

						<div v-else class="row mb-4 mb-lg-0">
							<div v-if="block.person_photo.src" class="col-8 offset-2 offset-sm-0 col-sm-4 col-md-4 col-lg-4 mb-3 mb-sm-0">
								<img :src="block.person_photo.src" class="rounded-circle">
							</div>
							<div class="col-12 col-sm-8 col-md-8 col-lg-8 align-self-center text-center text-sm-left">
								<div v-if="block.person_name" class="title">
									{{ block.person_name }}
								</div>
								<div v-if="block.about_person" class="description" v-html="block.about_person" />
							</div>
						</div>
					</div>

					<div v-if="block.description" class="col-12 col-lg-8">
						<div class="page-content">
							<div class="block-bio">
								<div class="row">
									<div class="col-12 col-lg-3">
										<div class="subtitle" />
									</div>
									<div class="col-12 col-lg-9">
										<div class="content description">
											<blockquote v-html="block.description" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>

	</div>
</template>

<script>

import panel from '~/mixins/panel'

export default {
	name: 'ResearchChart',
	mixins: [panel],
};
</script>
<style lang="scss" scoped>
	// Это потом удалить, если будет использоваться компонент HtmlRaw для цитаты
    @import "~/assets/styles/components/dev/html-raw-bio";
</style>
